module.exports = __webpack_public_path__ + "img/document_checked.bd81a300.svg";